import { render, staticRenderFns } from "./DraftHOC.vue?vue&type=template&id=03478934&"
import script from "./DraftHOC.vue?vue&type=script&lang=js&"
export * from "./DraftHOC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports